<form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
    <nav class="toolbar navbar navbar-light">
        <div class="form-inline">
            <button class="btnback btn btn-outline-success" type="button" title="Volver" (click)="onBack()"><i class="fa fa-chevron-left"></i></button>
            <button *ngIf="!visibilitySpinner" [disabled]="!habilitarGuardar" type="button" title="Guardar" (click)="onSaveProducto()" class="btn btn-outline-success "><i class="fa fa-save"></i> Guardar</button>
            <button *ngIf="visibilitySpinner" [disabled]="true" class="btn btn-outline-success">
                <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
                Guardando
            </button>
        </div>
    </nav>

    <app-partida-predua-popup (selected)="onAceptDialogPartidaPredua($event)"></app-partida-predua-popup>
    <app-especie-eppo-popup (selected)="onAcceptDialogEspecieEppo($event)" [esImportacion]="true"></app-especie-eppo-popup>

    <div class="animated fadeIn container-fluid">
        <h4 style="display:inline">{{ editTitle }} Producto {{ codigoSolicitud }}</h4>
        <h5 style="display:inline; margin-left: 8px">
            <span>
                <!--***ICONOS***-->
                <img class="estado-icono-big" container="body" src="{{IdTipoSolicitud | IconoTipoSolicitud}}" ngbTooltip="{{tituloTipoSolicitud}}" />
                <img class="estado-icono-big" container="body" src="{{IdEstadoSolicitud | IconoEstadoSolicitud}}" ngbTooltip="{{tituloEstadoSolicitud}}" />
                <img *ngIf="producto.IdEstadoChedPp" class="estado-icono-big" container="body" src="{{producto.IdEstadoChedPp | IconoEstadoChedPP}}" ngbTooltip="{{producto.IdEstadoChedPpDescripcion}}" />
                <img *ngIf="IdResultadoEnvioMuestrasLaboratorio" class="estado-icono-big" container="body" src="{{IdResultadoEnvioMuestrasLaboratorio | IconoResultadoEnvioMuestraLaboratorio}}" ngbTooltip="{{DescripcionIdResultadoEnvioMuestrasLaboratorio}}" />
                <img class="predua-icono-big" container="body" ngbTooltip="{{esPredua | preduaNoPredua}}" src="{{ esPredua | IconoPreduaSolicitud }}" />
                <img *ngIf="esClonada" class="estado-icono-big" container="body" src="{{ null | IconoEstadoSolicitud }}" ngbTooltip="Clonada" />
                <i *ngIf="esClonada" class="fa fa-clone clone-icono-big" ngbTooltip="Clonada"></i>
            </span>
        </h5>
        <ng-container *ngIf="productoFitosanitarioFound">
            <div class="nota-info warning mb-2">
                <label class="col-form-label" for=""><i class="fa fa-exclamation-triangle" aria-hidden="true"></i>: {{ messageProductoFitosanitarioLimit }}</label>
            </div>
        </ng-container>

        <div class="row">
            <div class="col-md-12">

                <div class="row">
                    <!--DATOS BASICOS -->
                    <div class="col-md-12">
                        <div class="card card-accent-success animated fadeIn">
                            <a class="card-header-a" (click)="isCollapsedDatosBasicos = !isCollapsedDatosBasicos" [attr.aria-expanded]="!isCollapsedDatosBasicos" aria-controls="collapseExample">
                                <div class="card-header-buscador">
                                    <i class="fa fa-file-text-o"></i> Datos básicos
                                    <i *ngIf="isCollapsedDatosBasicos" class="fa fa-caret-down float-right"></i>
                                    <i *ngIf="!isCollapsedDatosBasicos" class="fa fa-caret-up float-right"></i>
                                </div>
                            </a>
                            <div class="card-body-detalle">
                                <div class="collapse group-filtros" id="collapsedDatosBasicos" [ngbCollapse]="isCollapsedDatosBasicos">
                                    <div class="row">

                                        <div class="form-group col-md-3">
                                            <label class="col-form-label required-field" for="intEstado">Grupo</label>
                                            <ng-select [items]="listGrupo"
                                                       bindLabel="Descripcion"
                                                       bindValue="Id"
                                                       formControlName="IdGrupo"
                                                       loadingText="Cargando..."
                                                       [readonly]="!listGrupo || listGrupo.length === 0"
                                                       [loading]="!listGrupo"
                                                       notFoundText="Grupo no encontrado"
                                                       placeholder="-- Seleccione un Grupo --"
                                                       clearAllText="Eliminar selección"
                                                       [ngClass]="displayFieldCssNgSelect('IdGrupo')"
                                                       (change)="onSelectGrupo()">
                                                <ng-template ng-option-tmp let-item="item">
                                                    <div container="body" ngbTooltip="{{item.Descripcion}}">{{item.Descripcion}}</div>
                                                </ng-template>
                                            </ng-select>

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdGrupo','required')">
                                                Grupo es obligatorio
                                            </div>
                                        </div>

                                        <div class="form-group col-md-3">
                                            <label class="col-form-label required-field" for="intEstado">Forma</label>
                                            <ng-select [items]="listForma"
                                                       bindLabel="Descripcion"
                                                       bindValue="Id"
                                                       formControlName="IdForma"
                                                       loadingText="Cargando..."
                                                       [readonly]="!listForma || listForma.length === 0"
                                                       [loading]="!listForma && form.value.IdGrupo > 0"
                                                       notFoundText="Forma no encontrada"
                                                       placeholder="-- Seleccione una Forma --"
                                                       clearAllText="Eliminar selección"
                                                       [ngClass]="displayFieldCssNgSelect('IdForma')"
                                                       (change)="onSelectForma()">
                                                <ng-template ng-option-tmp let-item="item">
                                                    <div container="body" ngbTooltip="{{item.Descripcion}}">{{item.Descripcion}}</div>
                                                </ng-template>
                                            </ng-select>

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdForma','required')">
                                                Forma es obligatoria
                                            </div>
                                        </div>

                                        <!--SI NO ES PREDUA-->
                                        <div *ngIf="!esPredua" class="form-group col-md-3">
                                            <label class="col-form-label" [ngClass]="{ 'required-field' : campoObligatorio && campoDeclaracionSumaria }">Declaración Sumaria</label>
                                            <!--<i class="fa fa-info-circle icono-info-tooltip" placement="top" ngbTooltip="{{form.value.NumeroDeclaracionSumaria}}"></i>-->
                                            <input [attr.readonly]="numDecSumReadOnly ? true : null" formControlName="NumeroDeclaracionSumaria" placement="top" ngbTooltip="{{form.value.NumeroDeclaracionSumaria}}"
                                                   maxlength="39" name="NumeroDeclaracionSumaria" [ngClass]="displayFieldCss('NumeroDeclaracionSumaria')" title="" class="form-control" id="" type="text" value="">

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('NumeroDeclaracionSumaria','required')">
                                                Declaración Sumaria es obligatoria
                                            </div>
                                        </div>
                                        <!--SI ES PREDUA-->
                                        <div *ngIf="esPredua" class="form-group col-md-3">
                                            <label class="col-form-label required-field" for="">Declaración Sumaria</label>
                                            <input readonly formControlName="Mrn" maxlength="18" name="Mrn" [ngClass]="displayFieldCss('Mrn')" title="" class="form-control" id="" type="text" value="">

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('Mrn','required')">
                                                Declaración Sumaria es obligatoria
                                            </div>
                                        </div>

                                        <div *ngIf="esPredua" class="form-group col-md-3">
                                            <label class="col-form-label required-field" for="">Partida</label>
                                            <input [readonly]="esPredua" numbersOnly formControlName="Partida" name="Partida" [ngClass]="displayFieldCss('Partida')"
                                                   title="" class="form-control" id="Partida" type="text" value="" maxlength="3">

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('Partida','required')">
                                                Partida es obligatoria
                                            </div>
                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('Partida','maxlength')">
                                                Partida tiene una longitud incorrecta
                                            </div>
                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalidNoSubmit('Partida','pattern')">
                                                Formato incorrecto
                                            </div>
                                        </div>

                                    </div>

                                    <div class="row">

                                        <!--SI NO ES PREDUA-->
                                        <div *ngIf="!esPredua" class="form-group col-md-3">
                                            <label class="col-form-label required-field" for="inpDescripcion">C. Taric (Partida Arancelaria)</label>
                                            <input formControlName="CodigoTaric" numbersOnly name="CodigoTaric" [ngClass]="displayFieldCss('CodigoTaric')" title=""
                                                   class="form-control" id="inpNombre" type="text" value="" maxlength="10"><!--maxlength="10"-->

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('CodigoTaric','required')">
                                                Código Taric es obligatorio
                                            </div>
                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('CodigoTaric','maxlength')">
                                                El Código Taric debe tener 10 caracteres
                                            </div>
                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('CodigoTaric','minlength')">
                                                El Código Taric debe tener 10 caracteres
                                            </div>
                                        </div>
                                        <!--SI ES PREDUA-->
                                        <div *ngIf="esPredua" class="form-group col-md-3">
                                            <label class="col-form-label required-field" for="inpDescripcion">C. Taric (Partida Arancelaria)</label>
                                            <div class="input-group">
                                                <input readonly numbersOnly formControlName="CodigoTaric" name="CodigoTaric" title="" class="form-control" [ngClass]="displayFieldCss('CodigoTaric')" id="" type="text" value="">
                                                <span class="input-group-btn">
                                                    &nbsp;<button [disabled]="!habilitarGuardar" name="btnSearchCodigoTaric" class="btn btn-list btn-secondary" type="button" title="Buscar Código Taric" (click)="onSearchCodigoTaric()"><i class="fa fa-search"></i></button>
                                                </span>
                                            </div>

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('CodigoTaric','required')">
                                                Código Taric es obligatorio
                                            </div>
                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('CodigoTaric','maxlength')">
                                                El Código Taric debe tener 10 caracteres
                                            </div>
                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('CodigoTaric','minlength')">
                                                El Código Taric debe tener 10 caracteres
                                            </div>
                                        </div>

                                        <div class="form-group col-md-3">
                                            <label class="col-form-label" [ngClass]="{ 'required-field' : eppoObligatorio }" for="inpDescripcion">Código Eppo</label>
                                            <div class="input-group">
                                                <input readonly formControlName="CodigoEppo" name="CodigoEppo" title="" class="form-control" [ngClass]="displayFieldCss('CodigoEppo')" id="" type="text" value="">
                                                <span class="input-group-btn">
                                                    &nbsp;<button [disabled]="!habilitarBusquedaEppo" name="btnSearchCodigoEppo" class="btn btn-list btn-secondary" type="button" title="Buscar Código Eppo" (click)="onSearchCodigoEppo()"><i class="fa fa-search"></i></button>
                                                </span>
                                            </div>

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('CodigoEppo','required')">
                                                Código Eppo es obligatorio
                                            </div>
                                        </div>
                                        <div class="form-group col-md-3">
                                            <label class="col-form-label required-field" for="inpDescripcion">Nombre Botánico</label>
                                            <input readonly formControlName="NombreBotanico" [ngClass]="displayFieldCss('NombreBotanico')" name="NombreBotanico" title="" class="form-control" id="inpNRegistro" type="text" value="">

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('NombreBotanico','required')">
                                                Nombre Botánico es obligatorio
                                            </div>
                                        </div>
                                        <div class="form-group col-md-3">
                                            <label class="col-form-label required-field" for="inpDescripcion">Nombre Común</label>
                                            <input formControlName="NombreComun" name="NombreComun" [ngClass]="displayFieldCss('NombreComun')" maxlength="100" title="" class="form-control" id="inpNombre" type="text" value="">

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('NombreComun','required')">
                                                Nombre Común es obligatorio
                                            </div>
                                        </div>

                                    </div>

                                    <div class="row">
                                        <!--SI NO ES PREDUA-->
                                        <div *ngIf="!esPredua" class="form-group col-md-3">
                                            <label class="col-form-label required-field" for="intEstado">País Origen</label>

                                            <ng-select *ngIf="!esPredua"
                                                       [items]="listPais"
                                                       bindLabel="Descripcion"
                                                       bindValue="Id"
                                                       formControlName="IdPais"
                                                       loadingText="Cargando..."
                                                       [readonly]="!listPais || listPais.length === 0"
                                                       [loading]="!listPais || listPais.length === 0"
                                                       notFoundText="País no encontrado"
                                                       placeholder="-- Seleccione un País --"
                                                       clearAllText="Eliminar selección"
                                                       (change)="onSelectPais()"
                                                       [ngClass]="displayFieldCssNgSelect('IdPais')">
                                            </ng-select>

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdPais','required')">
                                                País Origen es obligatorio
                                            </div>
                                        </div>
                                        <!--SI ES PREDUA-->
                                        <div *ngIf="esPredua" class="form-group col-md-3">
                                            <label class="col-form-label required-field" for="intEstado">País Origen</label>
                                            <input readonly formControlName="PaisPredua" [ngClass]="displayFieldCss('PaisPredua')" title="" class="form-control"
                                                   id="" type="text">

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('PaisPredua','required')">
                                                País Origen es obligatorio
                                            </div>
                                        </div>

                                        <div class="form-group col-md-3">
                                            <label class="col-form-label required-field" for="inpDescripcion">Peso Neto (Kg)</label>
                                            <input formControlName="Peso" [decimalsOnly]="3" name="Peso" [ngClass]="displayFieldCss('Peso')"
                                                   maxlength="15" title="" class="form-control" id="peso" type="text" value="">

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('Peso','required')">
                                                Peso es obligatorio
                                            </div>
                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('Peso','DecimalTopCero')">
                                                Peso debe ser mayor que cero
                                            </div>
                                        </div>
                                        <div class="form-group col-md-3">
                                            <label class="col-form-label" for="inpDescripcion">Volumen (m³)</label>
                                            <input formControlName="Volumen" [decimalsOnly]="3" name="Volumen" maxlength="15" title="" class="form-control" id="" type="text" value="">
                                        </div>
                                        <div class="form-group col-md-3">
                                            <label class="col-form-label" for="inpDescripcion">Unidades (Ud)</label>
                                            <input formControlName="Unidades" numbersOnly name="Unidades" maxlength="10" title="" class="form-control" id="" type="text" value="">
                                        </div>

                                    </div>
                                    <div *ngIf="esPaisCE" class="row">
                                        <div class="form-group col-md-3">
                                            <label class="col-form-label required-field" for="intEstado">País Unión Europea</label>

                                            <ng-select [items]="listPaisUe"
                                                       bindLabel="Descripcion"
                                                       bindValue="Id"
                                                       formControlName="IdPaisReImportacion"
                                                       loadingText="Cargando..."
                                                       [readonly]="!listPaisUe || listPaisUe.length === 0"
                                                       [loading]="!listPaisUe || listPaisUe.length === 0"
                                                       notFoundText="País no encontrado"
                                                       placeholder="-- Seleccione un País --"
                                                       clearAllText="Eliminar selección"
                                                       [ngClass]="displayFieldCssNgSelect('IdPaisReImportacion')">
                                            </ng-select>

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdPaisReImportacion','required')">
                                                País Unión Europea es obligatorio
                                            </div>
                                        </div>
                                    </div>
                                    <!--RDLF: tarea producto Orgánico (93379) se comenta de manera temporal-->
                                    <!--<div class="row">
                                        <div class="form-group col-md-3">
                                            <label class="col-form-label">Orgánico</label>
                                            <i class="fa fa-info-circle icono-info-tooltip" placement="right" triggers="click" [autoClose]="'outside'" [ngbTooltip]="htmlTooltipOrganico"></i>
                                            <p-toggleButton class="form-control-togglebutton" formControlName="EsOrganico" onLabel="Sí" offLabel="NO"
                                                            onIcon="pi pi-check" offIcon="pi pi-times" id=""></p-toggleButton>
                                        </div>
                                    </div>-->

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">

                    <div class="col-md-12">
                        <!--BULTO-->
                        <div class="card card-accent-success animated fadeIn">
                            <a class="card-header-a" (click)="isCollapsedBulto = !isCollapsedBulto" [attr.aria-expanded]="!isCollapsedBulto" aria-controls="collapseExample">
                                <div class="card-header-buscador">
                                    <i class="fa fa-file-text-o"></i>
                                    Bulto
                                    <i *ngIf="isCollapsedBulto" class="fa fa-caret-down float-right"></i>
                                    <i *ngIf="!isCollapsedBulto" class="fa fa-caret-up float-right"></i>
                                </div>
                            </a>
                            <div class="card-body-detalle">
                                <div class="collapse group-filtros" id="collapsedBulto" [ngbCollapse]="isCollapsedBulto">
                                    <div class="row">

                                        <div class="form-group col-md-4">
                                            <label class="col-form-label" for="inpDescripcion">Marcas bulto</label>
                                            <input formControlName="MarcasBulto" name="MarcasBulto" maxlength="100" title="" class="form-control" id="" type="text" value="">
                                        </div>

                                        <div class="form-group col-md-4">
                                            <label class="col-form-label" for="inpDescripcion">Nº de bultos</label>
                                            <input formControlName="NumeroBulto" numbersOnly name="NumeroBulto" maxlength="10" title="" class="form-control" id="" type="text" value="">
                                        </div>

                                        <div class="form-group col-md-4">
                                            <label class="col-form-label required-field" for="intEstado">Tipo Bulto</label>
                                            <ng-select [items]="listBulto"
                                                       bindLabel="Descripcion"
                                                       bindValue="Id"
                                                       formControlName="IdTipoBulto"
                                                       loadingText="Cargando..."
                                                       [readonly]="!listBulto || listBulto.length === 0"
                                                       [loading]="!listBulto"
                                                       notFoundText="Tipo no encontrado"
                                                       placeholder="-- Seleccione un Tipo --"
                                                       clearAllText="Eliminar selección"
                                                       [ngClass]="displayFieldCssNgSelect('IdTipoBulto')">
                                            </ng-select>

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdTipoBulto','required')">
                                                Tipo Bulto es obligatorio
                                            </div>
                                        </div>

                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!--NRC-->
                <!--<div class="row">
                    <div class="col-md-12">
                        <div class="form-group col-md-3">
                            <label class="col-form-label" for="inpDescripcion">Nrc</label>
                            <input formControlName="Nrc" readonly name="Nrc" title="" class="form-control" id="" type="text" value="">
                        </div>
                    </div>
                </div>-->

            </div>

        </div>



    </div>

</form>

<!--RDLF: tarea producto Orgánico (93379) se comenta de manera temporal-->
<!--PLANTILLAS PARA EL TOOLTIP-->
<!--<ng-template #htmlTooltipOrganico>
    Este control se habilita si la solicitud contiene un documento de tipo 'Certificado de control - COI' <br />

</ng-template>-->


